module.exports = __webpack_public_path__ + "static/media/brutal-strength.b471f248.png";